import { j as e } from "./jsx-runtime.DGlMoOmv.js";
import { useFormContext as v } from "react-hook-form";
import { d as w, e as C, f as N, b as V, g as q } from "./Form.LdCd9gH2.js";
import { c as E } from "./index.CxSWpsOB.js";
import { S as M, h as I, i as L } from "./Select.BBX9C9N8.js";
const R = ({
  prefix: d,
  suffix: n,
  testId: s = "select",
  className: m,
  triggerClassName: c,
  label: u,
  subcopy: x,
  note: g,
  name: t,
  fullWidth: l = !1,
  renderContent: j,
  readOnly: f,
  placeholder: F,
  labelDataTestingId: h,
  buttonDataTestingId: S,
  getDynamicLabel: o,
  ...a
}) => {
  const {
    control: b
  } = v(), i = o ? o(t) : u;
  return /* @__PURE__ */ e.jsx(w, { control: b, name: t, render: ({
    field: r,
    ...p
  }) => /* @__PURE__ */ e.jsxs(C, { disabled: a.disabled, readOnly: f, className: E("tw-flex-1", {
    "tw-w-full": l
  }, m), children: [
    !!i && /* @__PURE__ */ e.jsx(N, { subcopy: x, required: a.required, "data-testing-id": h, children: i }),
    /* @__PURE__ */ e.jsxs(M, { onValueChange: r.onChange, defaultValue: r.value, value: r.value, ...a, children: [
      /* @__PURE__ */ e.jsx(V, { forwardErrorMsg: !0, children: /* @__PURE__ */ e.jsx(I, { "data-testing-id": S, fullWidth: l, className: c, prefix: d, suffix: n, ref: r.ref, testId: s ? `${s}-trigger` : void 0, children: /* @__PURE__ */ e.jsx(L, { disabled: a.disabled, placeholder: F }) }) }),
      j({
        field: r,
        ...p
      })
    ] }),
    /* @__PURE__ */ e.jsx(q, { children: g })
  ] }) });
};
R.displayName = "SelectField";
export {
  R as S
};
//# sourceMappingURL=SelectField.C9vLCSpS.js.map
